import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import './Attendance_dashboard.css';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { host, Host } from '../App';
import { FaUsers, FaUserCheck, FaUserTimes, FaCalendarAlt, FaArrowUp, FaArrowDown, FaExclamationTriangle, FaCheckCircle, FaChartLine } from 'react-icons/fa';

function Attendance_dashboard() {
  const [shift, setshift] = useState({});
  const [Data, setData] = useState([]);
  const [PT, setPT] = useState(0);
  const [PY, setPY] = useState(0);
  const [AT, setAT] = useState(0);
  const [AY, setAY] = useState(0);
  const [UV, setUV] = useState([]);
  const [EV, setEV] = useState([]);
  const [trendPT, setTrendPT] = useState('neutral');
  const [trendAT, setTrendAT] = useState('neutral');

  const [Date1, setDate1] = useState(new Date());
  const [Today, setToday] = useState("curdate()");
  const [yesterday, setYesterday] = useState('DATE_SUB(CURDATE(), INTERVAL 1 DAY)');
  var token = (window.localStorage.getItem("acessToken"));
  var user = (window.localStorage.getItem("Name"));
  const trial_status = "present";

  const Present_today = {
    Status: trial_status,
    token: token,
    Date: Today,
    user: user
  };

  const Absent_today = {
    Status: "Absent",
    token: token,
    Date: Today,
    user: user
  };

  const Present_yesterday = {
    Status: "Present",
    token: token,
    Date: yesterday,
    user: user
  };

  const Absent_yesterday = {
    Status: "Absent",
    token: token,
    Date: yesterday,
    user: user
  };

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/attendance/dashboard`, { params: Present_today }).then((data) => {
      const todayCount = data.data[0]?.count || 0;
      setPT(todayCount);
    });

    Axios.get(`https://` + Host + `/api/attendance/dashboard`, { params: Present_yesterday }).then((data) => {
      const yesterdayCount = data.data[0]?.count || 0;
      setPY(yesterdayCount);
      // Calculate trend
      if (PT > yesterdayCount) setTrendPT('up');
      else if (PT < yesterdayCount) setTrendPT('down');
      else setTrendPT('neutral');
    });

    Axios.get(`https://` + Host + `/api/attendance/dashboard`, { params: Absent_today }).then((data) => {
      const todayAbsent = data.data[0]?.count || 0;
      setAT(todayAbsent);
    });

    Axios.get(`https://` + Host + `/api/attendance/dashboard`, { params: Absent_yesterday }).then((data) => {
      const yesterdayAbsent = data.data[0]?.count || 0;
      setAY(yesterdayAbsent);
      // Calculate trend
      if (AT > yesterdayAbsent) setTrendAT('up');
      else if (AT < yesterdayAbsent) setTrendAT('down');
      else setTrendAT('neutral');
    });

    Axios.get(`https://` + host + `/api/upcoming_vaccation`, { params: Absent_yesterday }).then((data) => {
      setUV(data.data || []);
    });

    Axios.get(`https://` + host + `/api/ending_vaccation`, { params: Absent_yesterday }).then((data) => {
      setEV(data.data || []);
    });

  }, [PT, AT]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const getTrendIcon = (trend) => {
    switch (trend) {
      case 'up': return <FaArrowUp className="trend-icon up" />;
      case 'down': return <FaArrowDown className="trend-icon down" />;
      default: return <FaChartLine className="trend-icon neutral" />;
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1><FaChartLine /> Attendance Dashboard</h1>
        <p className="dashboard-subtitle">Real-time attendance insights and analytics</p>
      </div>

      <div className="stats-grid">
        <Link to='/attendanceDetails' className="stat-card present-today">
          <div className="stat-icon">
            <FaUserCheck />
          </div>
          <div className="stat-content">
            <h3>Present Today</h3>
            <div className="stat-value">{PT}</div>
            <div className="stat-trend">
              {getTrendIcon(trendPT)}
              <span className="trend-text">
                {trendPT === 'up' ? 'Increase' : trendPT === 'down' ? 'Decrease' : 'Same'} from yesterday
              </span>
            </div>
          </div>
        </Link>

        <Link to='/attendanceDetails' className="stat-card absent-today">
          <div className="stat-icon">
            <FaUserTimes />
          </div>
          <div className="stat-content">
            <h3>Absent Today</h3>
            <div className="stat-value">{AT}</div>
            <div className="stat-trend">
              {getTrendIcon(trendAT)}
              <span className="trend-text">
                {trendAT === 'up' ? 'Increase' : trendAT === 'down' ? 'Decrease' : 'Same'} from yesterday
              </span>
            </div>
          </div>
        </Link>

        <Link to='/attendanceDetails' className="stat-card present-yesterday">
          <div className="stat-icon">
            <FaUsers />
          </div>
          <div className="stat-content">
            <h3>Present Yesterday</h3>
            <div className="stat-value">{PY}</div>
            <div className="stat-comparison">
              <span className="comparison-label">Yesterday's Attendance</span>
            </div>
          </div>
        </Link>

        <Link to='/attendanceDetails' className="stat-card absent-yesterday">
          <div className="stat-icon">
            <FaExclamationTriangle />
          </div>
          <div className="stat-content">
            <h3>Absent Yesterday</h3>
            <div className="stat-value">{AY}</div>
            <div className="stat-comparison">
              <span className="comparison-label">Yesterday's Absence</span>
            </div>
          </div>
        </Link>
      </div>

      <div className="vacation-grid">
        <div className="vacation-card upcoming">
          <div className="card-header">
            <h2><FaCalendarAlt /> Upcoming Vacations</h2>
            <span className="badge">{UV.length} upcoming</span>
          </div>
          <div className="vacation-list">
            {UV.length > 0 ? (
              UV.map((val, key) => (
                <div key={key} className="vacation-item">
                  <div className="vacation-avatar">
                    {val.Name?.charAt(0) || 'U'}
                  </div>
                  <div className="vacation-details">
                    <h4>{val.Name || 'Unknown Employee'}</h4>
                    <div className="vacation-date">
                      <FaCalendarAlt />
                      <span>Starts: {formatDate(val.Start_Date)}</span>
                    </div>
                  </div>
                  <div className="vacation-status">
                    <span className="status-badge upcoming">Upcoming</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <FaCheckCircle />
                <p>No upcoming vacations</p>
              </div>
            )}
          </div>
        </div>

        <div className="vacation-card ending">
          <div className="card-header">
            <h2><FaCalendarAlt /> Ending Vacations</h2>
            <span className="badge">{EV.length} ending</span>
          </div>
          <div className="vacation-list">
            {EV.length > 0 ? (
              EV.map((val, key) => (
                <div key={key} className="vacation-item">
                  <div className="vacation-avatar">
                    {val.Name?.charAt(0) || 'U'}
                  </div>
                  <div className="vacation-details">
                    <h4>{val.Name || 'Unknown Employee'}</h4>
                    <div className="vacation-date">
                      <FaCalendarAlt />
                      <span>Ends: {formatDate(val.End_Date)}</span>
                    </div>
                  </div>
                  <div className="vacation-status">
                    <span className="status-badge ending">Ending Soon</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <FaCheckCircle />
                <p>No ending vacations</p>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <div className="actions-grid">
          <Link to="/attendance" className="action-btn">
            <FaUserCheck />
            <span>Mark Today's Attendance</span>
          </Link>
          <Link to="/attendanceDetails" className="action-btn">
            <FaChartLine />
            <span>View Attendance Reports</span>
          </Link>
          <Link to="/attendanceDetails" className="action-btn">
            <FaUsers />
            <span>Employee Management</span>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Attendance_dashboard